import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { statusLabel } from "./utils";

const PanelHeader = ({ request, onClose }) => {
  const theme = useTheme();
  const t     = theme.custom;

  return (
    <Box sx={{
      padding: "16px 20px 12px",
      borderBottom: `1px solid ${t.border2}`,
      flexShrink: 0,
    }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <Box>
          <Typography sx={{
            fontFamily: "'Inter', sans-serif",
            fontSize: "14px", fontWeight: 700,
            color: t.text, letterSpacing: "-0.01em",
          }}>
            {request.associateName} → {request.roleTitle}
          </Typography>
          <Typography sx={{
            fontFamily: "'DM Mono', monospace",
            fontSize: "9px", color: t.text3,
            mt: "3px", letterSpacing: "0.06em",
          }}>
            {request.requestCode} · {statusLabel(request.status)}
          </Typography>

          {request.currentMacName && (
            <Typography sx={{
              fontFamily: "'DM Mono', monospace",
              fontSize: "9px", color: t.text3,
              mt: "2px", letterSpacing: "0.06em",
            }}>
              Currently in: <Box component="span" sx={{ color: t.accent }}>{request.currentMacName}</Box>
            </Typography>
          )}
        </Box>

        <Box
          onClick={onClose}
          sx={{
            width: "28px", height: "28px",
            display: "flex", alignItems: "center", justifyContent: "center",
            borderRadius: "3px", cursor: "pointer",
            color: t.text3, fontSize: "14px",
            transition: "all 0.15s",
            "&:hover": { background: t.surface2, color: t.text },
          }}
        >
          ✕
        </Box>
      </Box>
    </Box>
  );
};

export default PanelHeader;